import React, { useState, useEffect } from 'react';
import ViewLugar from './ViewLugar';
import { useApiClient } from '../../clients/apiAuth';
import { connect } from 'react-redux';
import { store } from '../../store';
import { setSelLugar, setLugar, setContrato, showLoadingAnimation, hideLoadingAnimation, setLugarInit, setSelLugarInit } from '../../actions';
import toast from 'react-hot-toast';
import { CustomToast, ErrorToast, OkToast } from '../../components/specific/Toast';
import { CheckPermission } from '../../utils/security';

const Lugar = (props) => {
  const auth = props.auth;
  const contrato = props.contrato;
  const lugar = props.lugar;

  const { get, post, put, patch } = useApiClient();
  const [loadingTables, setLoadingTables] = useState(false);
  const [filterContrato, setFilterContrato] = useState('');

  const [municipioOptions, setMunicipioOptions] = useState([]);

  const [mostrarModal, setMostrarModal] = useState(false);

  const getFiltro = () => {
    const lstFiltros = [];

    if (filterContrato.length !== 0) {
      lstFiltros.push(`CONTRATO_ID=${filterContrato}`);
    }

    const firstElement = '?' + lstFiltros[0];

    if (lstFiltros.length === 1) {
      return firstElement;
    }

    lstFiltros.shift();

    if (lstFiltros.length === 1) {
      const restElements = '&' + lstFiltros[0];
      return firstElement.concat(restElements);
    }

    const restElements = lstFiltros.join('&');
    return firstElement + '&' + restElements;
  };

  const postLugar = async (form) => {
    store.dispatch(showLoadingAnimation());

    try {
      const result = await post(
        '/lugar',
        {
          json: JSON.stringify(form),
        },
        'application/json'
      );

      if (String(result.status).substr(0, 1) === '2') {
        OkToast({ result, message: 'Lugar creado exitosamente!' });
        getLugar();
        setMostrarModal(false);
      } else {
        CustomToast({ result });
      }
    } catch (error) {
      ErrorToast({ title: 'Error', message: error });
    } finally {
      store.dispatch(hideLoadingAnimation());
    }
  };

  const putLugar = async (form) => {
    store.dispatch(showLoadingAnimation());

    try {
      const result = await put(
        `/lugar/${form.LUGAR_ID}`,
        {
          json: JSON.stringify(form),
        },
        'application/json'
      );

      if (String(result.status).substr(0, 1) === '2') {
        OkToast({ result, message: 'Lugar actualizado exitosamente!' });
        getLugar();
        setMostrarModal(false);
      } else {
        CustomToast({ result });
      }
    } catch (error) {
      ErrorToast({ title: 'Error', message: error });
    } finally {
      store.dispatch(hideLoadingAnimation());
    }
  };

  const patchLugar = async (form) => {
    store.dispatch(showLoadingAnimation());

    try {
      const result = await patch(
        `/lugar/${form.LUGAR_ID}`,
        {
          json: JSON.stringify(form),
        },
        'application/json'
      );

      if (String(result.status).substr(0, 1) === '2') {
        OkToast({ result, message: 'Lugar actualizado exitosamente!' });
        getLugar();
        setMostrarModal(false);
      } else {
        CustomToast({ result });
      }
    } catch (error) {
      ErrorToast({ title: 'Error', message: error });
    } finally {
      store.dispatch(hideLoadingAnimation());
    }
  };

  const getMunicipio = async () => {
    try {
      const response = await get(`/municipio`);

      const lst = response.data.map((row) => ({
        label: `${row.MUNICIPIO_DESCRIPCION} (${row.MUNICIPIO_CODIGO})`,
        value: row.MUNICIPIO_CODIGO,
      }));

      setMunicipioOptions(lst);
    } catch (error) {}
  };

  const getLugar = async () => {
    if (filterContrato === '') {
      return;
    }
    const filtro = getFiltro();

    setLoadingTables(true);
    // const result = await get(`/lugar?CONTRATO_ID=${contratoID}&REFRESH=1`);
    const result = await get(`/lugar${filtro}&REFRESH=1`);
    store.dispatch(setLugar(result));
    setLoadingTables(false);
  };

  const handleAddLugar = async () => {
    store.dispatch(setSelLugarInit());
    setMostrarModal(true);
  };

  function handleEditLugar(obj) {
    store.dispatch(setSelLugar(obj));
    setMostrarModal(true);
  }

  const handleDepurar = async () => {
    if (filterContrato === '') {
      return;
    }
    toast((t) => (
      <span>
        <b>Está seguro que desea eliminar los lugares que no tienen servicios?</b>
        <button
          className="ml-2 rounded-full  border px-4 hover:bg-gray-200 "
          onClick={() => {
            toast.dismiss(t.id);
            depurarLugar(filterContrato);
          }}>
          Si
        </button>
        <button
          className="ml-2 rounded-full  border px-4 hover:bg-gray-200 "
          onClick={() => toast.dismiss(t.id)}>
          No
        </button>
      </span>
    ));
  };

  const depurarLugar = async (rowID) => {
    store.dispatch(showLoadingAnimation());

    try {
      const result = await post(`/depurarLugares/${rowID}`);

      if (String(result.status).substr(0, 1) !== '2') {
        //TODO MENOS LAS RESPUESTAS BUENAS.
        CustomToast({ result });
      } else {
        OkToast({ result, message: 'Lugares depurados!!!' });
        getLugar();
      }
    } catch (error) {
      ErrorToast({ title: 'Error', message: error });
    }

    store.dispatch(hideLoadingAnimation());
  };

  const getContrato = async () => {
    try {
      const response = await get(`/contrato?TERCERO_ID=${auth.data.selCliente.TERCERO_ID}`);
      store.dispatch(setContrato(response));
      setFilterContrato(response.data[0]['CONTRATO_ID']);
    } catch (error) {}
  };

  function handleEstado(obj) {
    console.log('handleEstado', obj);

    const isAdmin = CheckPermission('Coordinador') || CheckPermission('Administrador');

    if (!isAdmin) {
      toast.error('No tiene permisos para realizar esta acción.');
      return;
    }

    const form = {
      LUGAR_ID: obj.LUGAR_ID,
      LUGAR_ESTADO: obj.LUGAR_ESTADO ? 0 : 1,
    };

    console.log(form);

    patchLugar(form);
  }

  useEffect(() => {
    getContrato();
    getMunicipio();
  }, []);

  useEffect(() => {
    getLugar();
  }, [filterContrato]);

  return (
    <ViewLugar
      endPoint={{
        getLugar,
        getContrato,
        postLugar,
        putLugar,
      }}
      data={{
        auth,
        contrato,
        lugar,
        filterContrato,
        setFilterContrato,
        municipioOptions,
      }}
      actions={{
        loadingTables,
        handleEstado,
        handleDepurar,
        handleAddLugar,
        handleEditLugar,
      }}
      modal={{ mostrarModal, setMostrarModal }}
    />
  );
};

const mapStateToProps = function (state) {
  return {
    auth: state.auth,
    lugar: state.lugar,
    contrato: state.contrato,
  };
};

//export default Projects;
export default connect(mapStateToProps)(Lugar);
